import { setError } from '../store/error/action-creators';
import { ErrorKey } from '../app-active-error/ErrorKey';
export const handleRegisteredLeadsSuccess = (response, dispatch) => {
  if (response.length === 0) {
    dispatch(setError(ErrorKey.PartnerNoRegisteredLeads));
  }
};